import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  O3rComponent,
} from '@o3r/core';
import {
  LocalizationService,
} from '@o3r/localization';
import {
  RefundTeaserPresComponent,
} from '@refx/servicing-components';

@O3rComponent({
  componentType: 'ExposedComponent'
})
@Component({
  selector: 'custom-refund-teaser-pres',
  styleUrls: ['./custom-refund-teaser-pres.style.scss'],
  templateUrl: './custom-refund-teaser-pres.template.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CustomRefundTeaserPresComponent extends RefundTeaserPresComponent {
  constructor(localizationService: LocalizationService) {
    super(localizationService);
  }
}
